import { RichUtils } from "draft-js";

/**
 * @param {EditorState} editorState
 * @param {Function}    onChange
 */
export default function toggleInlineStyle(editorState, onChange) {
  return inlineStyle => () => {
    const afterStyleToggle = RichUtils.toggleInlineStyle(editorState, inlineStyle);
    onChange(afterStyleToggle);
  };
}
